import React from "react";
import { motion } from "framer-motion";

export default function FinalCTA() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="final-cta" data-testid="final-cta-section" className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-ink-900 via-ink-800 to-ink-900" />
      <div className="pointer-events-none absolute inset-0 bg-grain opacity-30 mix-blend-overlay" />
      <div className="pointer-events-none absolute -left-32 top-1/3 h-72 w-72 rounded-full bg-gold/15 blur-[140px]" />
      <div className="pointer-events-none absolute -right-32 bottom-1/3 h-72 w-72 rounded-full bg-gold/10 blur-[160px]" />

      <div className="relative mx-auto max-w-5xl px-6 py-32 text-center md:py-44">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
        >
          <div className="mb-6 flex items-center justify-center gap-3 text-xs uppercase tracking-[0.3em] text-gold">
            <span className="h-px w-10 bg-gold/60" />
            The Choice
            <span className="h-px w-10 bg-gold/60" />
          </div>
          <h2 className="font-display text-4xl font-bold leading-[1.05] text-white md:text-6xl lg:text-7xl">
            You can <span className="text-stroke-gold">crash out</span> —
            <span className="block">or you can <span className="text-gradient-gold">cash out</span></span>
            <span className="block">your gifts, purpose, and potential.</span>
          </h2>
          <p className="mx-auto mt-8 max-w-2xl text-lg text-zinc-300">
            The blueprint is here. The brotherhood is real. The next move is yours.
          </p>

          <div className="mt-12 flex flex-wrap justify-center gap-3">
            <button
              data-testid="final-cta-school"
              onClick={() => scrollTo("#curriculum")}
              className="btn-gold rounded-full px-7 py-4 text-sm font-semibold uppercase tracking-wider"
            >
              <i className="fa-solid fa-graduation-cap mr-2" />
              Bring This Program To Your School
            </button>
            <button
              data-testid="final-cta-book-speaker"
              onClick={() => scrollTo("#speaking")}
              className="btn-ghost-gold rounded-full px-7 py-4 text-sm font-semibold uppercase tracking-wider"
            >
              <i className="fa-solid fa-microphone-lines mr-2" />
              Book Mr. Green Bay
            </button>
            <button
              data-testid="final-cta-join"
              onClick={() => scrollTo("#sponsor")}
              className="btn-ghost-gold rounded-full px-7 py-4 text-sm font-semibold uppercase tracking-wider"
            >
              <i className="fa-solid fa-fire mr-2" />
              Sponsor A Youth
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
